// Imported RELATIVELY on purpose: this leaf is in the root vitest configs' config-load closure, where a `@federa/*`
// specifier reads MAIN on a worktree; the closure's relativity walk (const/__tests__/vitest-workerd-tier.test.ts) pins it.
import { ENV_LOCAL_FILE } from './env-files.ts';
import { NODE_MODULES_DIR } from './file-paths.ts';

/** Bytes per binary kilobyte (KiB), and the base every larger binary unit steps by -- so a size ladder walks powers of
 *  this ONE number instead of each rung re-spelling `1024`. {@link BYTES_PER_MB} is derived from it below. */
export const BYTES_PER_KB = 1024;

/** Bytes per binary megabyte (MiB). */
export const BYTES_PER_MB = BYTES_PER_KB * BYTES_PER_KB;
export const WORKTREE_DIR = '.worktrees' as const;
/** Files to symlink from project root into worktrees. */
export const SYMLINK_TARGETS = [NODE_MODULES_DIR, ENV_LOCAL_FILE] as const;
